module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Nate David-d59801c8b858b66094c480285988a39f.jpg";